<template>
  <div>
    <canvas id="incomeChart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'
import 'chartjs-adapter-moment'
const { getSeconds } = require('@/util/timeUtil.js')
const { getTimeFormat } = require('@/util/timeUtil.js')

export default {
    name: 'IncomeChart',
    props: {
        totalAmount: Array,
        date: Array
    },
    data: () => (
        { Chart_2: '' }
    ),
    mounted () {
        this.makeGraph()
    },
    methods: {
        makeGraph () {
            const total = []
            for (let i = 0; i < this.date.length; i++) {
                total[i] = { x: this.date[i], y: this.totalAmount[i] / 100 }
            }
            const ctx = document.getElementById('incomeChart').getContext('2d')
            const gradient = ctx.createLinearGradient(0, 0, 0, 450)
            gradient.addColorStop(0, 'rgba(246, 255, 0, 0.5)')
            gradient.addColorStop(1, 'rgba(246, 255, 0, 0)')
            this.chart_2 = new Chart(ctx, {
                type: 'line',
                data: {
                    datasets: [
                        {
                            data: total,
                            label: 'Total Earnings',
                            pointBackgroundColor: '#020067',
                            borderWidth: 2.0,
                            fill: false,
                            borderColor: '#1713E3',
                            pointRadius: 4,
                            pointBorderColor: '#020067'
                        }
                    ]
                },
                options: {
                    interaction: {
                        mode: 'index'
                    },
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom',
                            align: 'end',
                            usePointStyle: true,
                            boxWidth: 10,
                            labels: {
                                boxWidth: 10
                            }
                        },
                        tooltip: {
                            titleFont: {
                                size: 15
                            },
                            bodyFont: {
                                size: 15
                            },
                            callbacks: {
                                enabled: true,
                                title: function (ToolTipItem) {
                                    const date = new Date(Number(ToolTipItem[0].parsed.x)).toLocaleDateString('en-us', { day: 'numeric', year: 'numeric', month: 'short' })
                                    return date
                                },
                                label: function (context) {
                                    const label = context.dataset.label + ' - ₹' + new Intl.NumberFormat('en-IN').format(context.parsed.y)
                                    return label
                                }
                            }
                        }
                    },
                    scales: {
                        xAxes: {
                            type: 'time',
                            ticks: {
                                font: function (context) {
                                    var width = context.chart.width
                                    if (width > 400) {
                                        return {
                                            size: 13
                                        }
                                    } else {
                                        return {
                                            size: 11
                                        }
                                    }
                                },
                                callback: function (label, index, labels) {
                                    if (/\s/.test(label)) {
                                        return label.split(' ')
                                    } else {
                                        return label
                                    }
                                }
                            },
                            time: {
                                unit: function () {
                                    const seconds = getSeconds(total[0].x, total[total.length - 1].x)
                                    return getTimeFormat(seconds)
                                }
                            },
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            offset: true,
                            grid: {
                                display: false,
                                drawBorder: false
                            },
                            beginAtZero: false,
                            ticks: {
                                font: function (context) {
                                    var width = context.chart.width
                                    if (width > 400) {
                                        return {
                                            size: 13
                                        }
                                    } else {
                                        return {
                                            size: 11
                                        }
                                    }
                                },
                                callback: function (value, index, values) {
                                    if (Number(value) === 0) {
                                        return value
                                    }
                                    if (Number(value) >= 1000) {
                                        const num = Number(value) / 1000
                                        return '₹' + num + ' K'
                                    }
                                    return '₹' + new Intl.NumberFormat('en-IN').format(value)
                                }
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            })
        }
    }
}
</script>

<style>
    #incomeChart {
        height: 410px !important
    }

    @media (max-width:480px) {
        #incomeChart {
            height: 320px !important
        }
    }
</style>
